var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-icon btn-sm border-0 btn-hover-primary mr-2 my-1",on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.pageNumber)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }